import React from 'react';
import displayName from 'component-lib/displayName';
import styles from './Login.scss';

function PCCLoginLogo(props) {
    return <header className={styles['login-logo-pcc']} {...props} />
}

PCCLoginLogo.displayName = displayName('Login/PCCLoginLogo');

export default PCCLoginLogo;
